import React from 'react';
import { Box } from '@chakra-ui/react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import TaskColumn from './TaskColumn';
import { Task, Column } from '../types';

interface SortableColumnProps {
  column: Column;
  tasks: Task[];
  onTaskClick: (task: Task) => void;
  onDelete?: (columnId: string) => void;
  isFinished?: boolean;
  onSetAsFinished?: (columnId: string) => void;
  canReorderColumns?: boolean;
}

const GripIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" opacity={0.6}>
    <circle cx="6" cy="8" r="2" />
    <circle cx="12" cy="8" r="2" />
    <circle cx="18" cy="8" r="2" />
    <circle cx="6" cy="14" r="2" />
    <circle cx="12" cy="14" r="2" />
    <circle cx="18" cy="14" r="2" />
  </svg>
);

const SortableColumn: React.FC<SortableColumnProps> = ({
  column,
  tasks,
  onTaskClick,
  onDelete,
  isFinished,
  onSetAsFinished,
  canReorderColumns = true,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: column.id, disabled: !canReorderColumns });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <Box
      ref={setNodeRef}
      style={style}
      minW={{ base: '100%', md: '320px' }}
      maxW={{ base: '100%', md: '320px' }}
      display="flex"
      flexDirection="column"
    >
      <TaskColumn
        id={column.id}
        title={column.title}
        color={column.color}
        tasks={tasks}
        onTaskClick={onTaskClick}
        onDelete={onDelete}
        isFinished={isFinished}
        onSetAsFinished={onSetAsFinished}
        dragHandle={canReorderColumns ? (
          <Box
            {...attributes}
            {...listeners}
            cursor="grab"
            _active={{ cursor: 'grabbing' }}
            p={1}
            mr={1}
            borderRadius="md"
            _hover={{ bg: 'rgba(0,0,0,0.06)' }}
            title="Prevucite za promenu redosleda"
          >
            <GripIcon />
          </Box>
        ) : undefined}
      />
    </Box>
  );
};

export default SortableColumn;
